jQuery(document).ready(function($) {

    var formInput = $('input[type=text]');

	formInput.focus(function() {

	  console.log('clicked on input');

	  $( this ).prev('label').addClass('active-label');

	});

	formInput.blur(function() {
		$( this ).prev('label').removeClass('active-label');

	});
});